<ng-template #forceTfaAlert>
  {{ 'shared:alerts.forceTFAAlert.notification' | i18next }} {{ 'shared:alerts.forceTFAAlert.daysLeft' | i18next: { count: leftDays } }}
  <mbs-button [isCtrl]="true"
              (click)="openTFAModal()"
              size="inherit">{{ 'shared:alerts.forceTFAAlert.enableNow' | i18next }}
  </mbs-button>
</ng-template>
